// Per-route SEO tags.
//
// The app uses hash routing, so a fragment (/#/donate) is not a separate URL for search engines:
// https://letsssl.com/ is the only page that can be indexed, and every console route is marked noindex.
// The canonical link therefore always points at the site root.
const SITE = 'https://letsssl.com';
const CANONICAL = SITE + '/';

const DEFAULTS = {
    title: "Let's SSL - Free SSL Certificate Automation Service",
    description: "Let's SSL provides free SSL certificate automation using Let's Encrypt. Secure your website with trusted SSL certificates, automated renewal, and easy domain validation.",
    robots: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
};

const PRIVATE_ROBOTS = 'noindex, follow';

// Updates the tag in <head> when it is there (it is, see public/index.html) and creates it otherwise
function setContent(selector, attribute, value) {
    let tag = document.head.querySelector(selector);
    if (!tag) {
        const isLink = selector.startsWith('link');
        tag = document.createElement(isLink ? 'link' : 'meta');
        const name = /name="([^"]+)"/.exec(selector);
        const property = /property="([^"]+)"/.exec(selector);
        if (name) tag.setAttribute('name', name[1]);
        else if (property) tag.setAttribute('property', property[1]);
        if (isLink) tag.setAttribute('rel', selector.includes('canonical') ? 'canonical' : '');
        document.head.appendChild(tag);
    }
    tag.setAttribute(attribute, value);
}

export const siteDefaults = DEFAULTS;
export const privateRobots = PRIVATE_ROBOTS;

export function applyRouteSeo(route) {
    const meta = (route && route.meta) || {};
    const title = meta.title || DEFAULTS.title;
    const description = meta.description || DEFAULTS.description;
    const robots = meta.robots || DEFAULTS.robots;

    document.title = title;
    setContent('meta[name="description"]', 'content', description);
    setContent('meta[name="robots"]', 'content', robots);
    setContent('meta[name="googlebot"]', 'content', robots);
    setContent('link[rel="canonical"]', 'href', CANONICAL);
    setContent('meta[property="og:title"]', 'content', title);
    setContent('meta[property="og:description"]', 'content', description);
    setContent('meta[property="og:url"]', 'content', CANONICAL);
    setContent('meta[property="twitter:title"]', 'content', title);
    setContent('meta[property="twitter:description"]', 'content', description);
}
